<template lang="">
  <div>
    <ul class="w_1180 about_tit" style="height:auto; overflow:hidden; text-align:center;">
      <li v-for="(item, index) in topList" :key="index" :class="{ active: activeIndex == item.path }" @click="setActive(item.path)">
        <router-link :to="item.path">{{ item.text }}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
     activeIndex:'',
     topList:[
     { text: '关于小鸟', path: '/about' },
        { text: '顾问团队', path: '/team' },
        { text: '企业文化', path: '/culture' },
        { text: '资质证书', path: '/certificate' },
        { text: '合作客户', path: '/partner' },
        { text: '资讯动态', path: '/news' },
        { text: '媒体资料', path: '/media' },
        { text: '加入我们', path: '/join' },
        { text: '支付方式', path: '/pay' },
        // { text: '联系方式', path: '/contact' }
     ]
    }
  },
  mounted() {
    this.activeIndex=this.$route.path;
  },
  watch:{
  },
  methods: {
    setActive(index){
      this.activeIndex=index
    }
  },
}
</script>
<style lang="">
  
</style>